import {makeStyles} from '@material-ui/core';
import React from 'react';
import PageHeader from '../../../elements/PageHeader';
import VariantsList from './VariantsList/VariantsList';
import {useInitializeProductVariant} from '../utils';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    background: '#f8f9fb',
  },
  content: {
    width: '100%',
    padding: theme.spacing(3),
  },
}));

const Variants = () => {
  const classes = useStyles();
  useInitializeProductVariant();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <PageHeader backButton title="Variantes de producto" />

        <VariantsList />
      </div>
    </div>
  );
};

export default Variants;
